module.exports = __webpack_public_path__ + "img/cruise_travel_insurance.f6be840f.webp";